/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { getDashboardResponseDataSchema } from '../getDashboard/get-dashboard-response';
import { distinctStatsSchema } from './distinct-stats-schema';
import { levelStatsV2Schema } from './level-stats-v2-schema';

export const getDashboardV2ResponseDataSchema = getDashboardResponseDataSchema.extend({
  levels: z.record(z.string(), levelStatsV2Schema),
  distinct: distinctStatsSchema,
});

export type IGetDashboardV2ResponseData = z.infer<typeof getDashboardV2ResponseDataSchema>;

export const getDashboardV2ResponseSchema = createApiResponseSchema(
  getDashboardV2ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetDashboardV2ResponseData>>;

export type IGetDashboardV2Response = IAPI<IGetDashboardV2ResponseData>;
